(() => {
  function boot(root = document) {
    root.querySelectorAll('[data-wn-conversion-scroll-buy]').forEach((button) => {
      if (button.dataset.wnReady === 'true') return;
      button.dataset.wnReady = 'true';
      button.addEventListener('click', () => {
        const target = document.querySelector('.wn-product-buybox [data-add-to-cart]') || document.querySelector('[data-add-to-cart]');
        const options = document.querySelector('.wn-product-buybox [data-wn-guided-choice]') || target;
        (options || target)?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        window.setTimeout(() => target?.focus({ preventScroll: true }), 350);
      });
    });
  }
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
})();
